import React from "react"
import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"
import GlobalHelper from "../../../GlobalHelper.jsx"
import Icon from "../../../icon/icon.component.jsx"

const MatrixCreationButton = () => {
    return (
        <>
            {GlobalHelper.IsFeatureFlagEnabled("lSRetailImportMatrix") && (
                <Link to="/imports/products-matrix" className="btn btn-outline-primary">
                    <Icon value="download" />
                    <FormattedMessage
                        id="generic-listing.import-btn-text"
                        defaultMessage="Import"
                    />
                </Link>
            )}
            <Link to="/matrices/new" className="btn btn-primary">
                <Icon value="plus-circle" />
                <FormattedMessage
                    id="generic-listing.matrices.create-btn-text"
                    defaultMessage="New"
                />
            </Link>
        </>
    )
}

export default MatrixCreationButton



// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/MatrixCreationButton.tsx